// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsEngagementReportsEngagementReportsDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      compression: string,
      delimiter: string,
      email_to: arrayOf(string),
      created_at: number,
      tag_names: arrayOf(string),
      marked_as_deleted: boolean,
    })
  ),
});
